
export enum PrintFBDSDocumentsTypeCd {
	DOT_MATRIX = 'DotMatrix',
	LASER = 'Laser'}
